<template>
	<vx-card class="prazo-card-alerts prazo-card mb-6">
		<vs-collapse>
			<vs-collapse-item :open="true">
				<div slot="header">
					<div class="flex">
						<h3 class="flex items-center text-lg">Prazos em alerta</h3>
						<vs-chip v-if="prazos" color="primary" class="ml-2 font-semibold">{{ prazos.length }}</vs-chip>
					</div>
				</div>

				<VuePerfectScrollbar
					class="prazo-scroll-area"
					:settings="settingsPerfectScroll"
					@ps-scroll-y.native="scrollListener"
				>
					<ul class="prazo-alerts-list" :class="{'pb-24': prazos && prazos.length}">
						<li
							class="flex justify-start cursor-pointer"
							v-for="(prazo, index) in prazos"
							:key="index"
						>
							<vs-alert
								@click="() => editarPrazo(prazo)"
								active="true"
								class="mt-5"
								icon-pack="feather"
								icon="icon-info"
								:color="
									prazo.situacao == 'ATRASADO'
										? 'danger'
										: prazo.situacao == 'EM_ALERTA'
										? 'warning'
										: ''
								"
							>
								<div class="mx-2">
									<h4
										class="prazo-titulo"
										:class="{
											'text-danger':
												prazo.situacao == 'ATRASADO',
											'text-warning':
												prazo.situacao == 'EM_ALERTA'
										}"
									>
										{{ prazo.titulo }}
									</h4>
									<p
										class="prazo-descricao"
										:class="{
											'text-danger':
												prazo.situacao == 'ATRASADO',
											'text-warning':
												prazo.situacao == 'EM_ALERTA'
										}"
									>
										{{ prazo.descricao }}
									</p>
								</div>
							</vs-alert>
						</li>

						<li v-if="!prazos" class="opacity-0">
							<p >Carregando os prazos em alerta...</p>
						</li>

						<li v-if="prazos && !prazos.length" class="nenhum-item">
							<h5 class="flex items-center text-sm">Nenhum prazo em alerta</h5>
						</li>
					</ul>
				</VuePerfectScrollbar>
			</vs-collapse-item>
		</vs-collapse>
	</vx-card>
</template>

<script>
import Prazo from "../../../../../models/Prazo";
import scrollInfinito from '../../../../../helpers/getDataByScroll';

import { mapState } from "vuex";

export default {
	name: "CardAlerts",
	data() {
		return {
			prazos: null,
			settingsPerfectScroll: {
				wheelSpeed: 0.2,
			},
			prazosConfigs: {
                isLoading: false,
				listSize: 20,
				filters: {
					limit: 20,
					situacao: "EM_ALERTA,ATRASADO",
				},
                currentPage: 1,
                isMaxPage: false,
            }
		};
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		...mapState(["prazoToEditar"]),
	},
	methods: {
		async getPrazos() {
			const loadingPrazos = this.$vsloading({
				container: ".prazo-card-alerts .vs-collapse-item--content",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44,
				isFullPage: true
			});

			try {
				const { prazos } = await Prazo.getPrazosPorEmpresa(
					this.empresaPk,
					{
						limit: 20,
						situacao: "EM_ALERTA,ATRASADO"
					}
				);

				this.prazos = prazos;
				this.defaultPrazosConfigs();
			} catch (error) {
				console.error(error);
			} finally {
				setTimeout(loadingPrazos.hide, 200);
			}
		},
		editarPrazo(prazo) {
			this.$store.state.prazoToEditar = prazo.pk;
		},
		async morePrazos(params) {

            const data = {
                count: 0,
                data: []
            }

            try {

                if (!params) {
                    params = {limit: 20};
				}

				params["situacao"] = "EM_ALERTA,ATRASADO";

                const { prazos, totalPrazos } = await Prazo.getPrazosPorEmpresa(
					this.empresaPk,
					params
				);

                data.data = prazos;
                data.count = totalPrazos;

            } catch (error) {
				console.error(error);
            }

            return data;
        },
		async scrollListener(event) {

            this.prazosConfigs['getData'] = this.morePrazos;

            let data = await scrollInfinito.run(event, this.prazosConfigs, true);

			if (data) {
				this.prazos = [
					...this.prazos,
					...data
				];
			}
		},
		defaultPrazosConfigs() {
            this.prazosConfigs = {
                isLoading: false,
				listSize: 20,
				filters: {
					limit: 20,
					situacao: "EM_ALERTA,ATRASADO",
				},
                currentPage: 1,
                isMaxPage: false,
            };
		},
	},
	watch: {
		prazoToEditar: {
			deep: true,
			handler(prazo) {
				if (!prazo) {
					this.getPrazos();
				}
			}
		},
	},
	mounted() {
		this.getPrazos();
	}
};
</script>

<style lang="scss" src="./card_alerts.scss"></style>
